<script>
export default {
  props: {
    text: {
      type: String,
      default: '新建'
    }
  }
}
</script>

<template>
  <div class="eu-select-add">
    <div class="pos">
      <div class="operate"><i class="el-icon-plus"></i>&nbsp;&nbsp;{{ text }}</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .eu-select-add {
    height: 40px;
    .pos {
      position: absolute;
      height: inherit;
      line-height: 40px;
      background: var(--color-fill-2);
      padding-left: 20px;
      bottom: 0;
      left: 0;
      right: 0;
      width: 100%;
      display: flex;
      &:hover {
        cursor: pointer;
        color: var(--color-primary);
      }
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 1px;
        width: 100%;
        background: var(--color-fill-3);
      }
    }
  }
</style>